module.exports = __webpack_public_path__ + "static/media/mobileViewBack.90f4a519.png";